import VueSplit from './Split.vue'

export default VueSplit


// WEBPACK FOOTER //
// ./src/index.js